import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import useDocumentFile from '../../hooks/useDocumentFile';
import AppLoaderContent from '../../../../app/features/loader/content/AppLoaderContent';

type FDocumentViewerProps = {
	documentId: number;
	onError?: () => void;
};

const FDocumentViewer = (props: FDocumentViewerProps) => {
	const { documentId, onError } = props;
	const { document: currentDocument, getBlob } = useDocumentFile(documentId);

	const [state, setState] = useState<string | null>(null);
	const [fileUrl, setFileUrl] = useState<string | null>(null);

	useEffect(() => {
		if (currentDocument && state === null) {
			setState('start');
			getBlob()
				.then((blob) => {
					setFileUrl(window.URL.createObjectURL(blob as Blob));
					setState('end');
				})
				.catch(() => {
					onError?.();
				});
		}
	}, [currentDocument, getBlob, onError, state]);

	useEffect(() => {
		// Read latest `fileUrl` via the functional updater — depending directly on
		// `fileUrl` would trigger this on every URL load and revoke immediately.
		return () => {
			setFileUrl((prev) => {
				if (prev) window.URL.revokeObjectURL(prev);
				return null;
			});
			setState(null);
		};
	}, [documentId]);

	return (
		<>
			{fileUrl ? (
				<Box sx={{ width: '100%', height: 'calc(100vh - 280px)' }} id="document-pdf-viewer">
					<iframe
						src={fileUrl}
						title="Document viewer"
						style={{ width: '100%', height: '100%', border: 'none' }}
					/>
				</Box>
			) : (
				<AppLoaderContent />
			)}
		</>
	);
};

export default FDocumentViewer;
